<template>
  <div>
    <b-modal id="modalAviso" :header-text-variant="'text-center'" size="lg" title="Aviso de troca de plano" hide-footer :static="true" :lazy="true">
      <template #modal-header>
        <div class="d-flex justify-content-between align-items-center w-100">
          <h4 class="modal-title">Aviso de Troca de Plano</h4>
          <button class="close" @click="closeModal">&times;</button>
        </div>
      </template>
      <div class="alert alert-warning text-center">
        <p class="font-weight-bold">
          Existem itens no seu carrinho de compras, eles serão excluídos para que possa seguir na troca de plano. Deseja continuar?
        </p>
      </div>
      <div class="mt-4">
        <div class="row">
          <div class="col-6">
            <b-button variant="secondary" @click="closeModal">Não</b-button>
          </div>
          <div class="col-6 text-right">
            <b-button variant="primary" @click="confirmAction">Continuar</b-button>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  mounted () {},
  methods: {
    openModal () {
      this.$bvModal.show('modalAviso')
    },
    closeModal () {
      this.$router.push('/carrinho')
      this.$bvModal.hide('modalAviso')
    },
    confirmAction () {
      this.$bvModal.hide('modalAviso')
    }
  }
}
</script>

<style scoped>
.modal-title {
  margin: 0;
  font-size: 1.5rem;
}

.alert-warning {
  background-color: #fff3cd;
  border-color: #ffeeba;
  color: #856404;
}

.close {
  background: none;
  border: none;
  font-size: 1.5rem;
  line-height: 1;
  color: #000;
  opacity: 0.5;
}

.close:hover {
  opacity: 1;
}

.botoes {
  margin-left: auto;
}

.mt-4 {
  margin-top: 1.5rem;
}
</style>
